export const formatExportDateForFilename = (
  value: Date,
  includeSeconds = false
) => {
  const year = value.getFullYear();
  const month = `${value.getMonth() + 1}`.padStart(2, '0');
  const day = `${value.getDate()}`.padStart(2, '0');
  const hours = `${value.getHours()}`.padStart(2, '0');
  const minutes = `${value.getMinutes()}`.padStart(2, '0');
  const seconds = includeSeconds
    ? `${value.getSeconds()}`.padStart(2, '0')
    : '';

  return includeSeconds
    ? `${year}${month}${day}_${hours}${minutes}${seconds}`
    : `${year}${month}${day}_${hours}${minutes}`;
};

export const sanitizeFilenamePart = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toLowerCase();

export const buildExportFileName = ({
  analysisName,
  section,
  exportDate = new Date(),
}: {
  analysisName: string;
  section: string;
  exportDate?: Date;
}) => {
  const analysisPart = sanitizeFilenamePart(analysisName || 'analisi');
  const datePart = formatExportDateForFilename(exportDate);
  return `${analysisPart}_${section}_export-${datePart}`;
};

export const buildExcelExportFileName = ({
  analysisName,
  section = 'evoluzione-segnali',
  variantSuffix,
  exportDate = new Date(),
}: {
  analysisName: string;
  section?: string;
  variantSuffix?: string;
  exportDate?: Date;
}) => {
  const analysisPart = sanitizeFilenamePart(analysisName || 'analisi');
  const sectionPart = sanitizeFilenamePart(section);
  const variantPart = variantSuffix
    ? `_${sanitizeFilenamePart(variantSuffix)}`
    : '';
  const datePart = formatExportDateForFilename(exportDate, true);
  return `${analysisPart}_${sectionPart}${variantPart}_export-${datePart}.xlsx`;
};
